import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverPouchOperationEntity } from '../../domain/entities/DriverPouchOperationEntity'

export class DriverPouchOperationModel extends DriverPouchOperationEntity {
  dateTime?: string
  constructor(dataDto: DriverPouchOperationModel) {
    super()
    mapEntityProperties<DriverPouchOperationModel>(this, dataDto,{
      map: {
        startDate: dataDto.dateTime
      }
    })
  }
}